(function () {
  var STORAGE_KEY = 'skintypes_favorites';

  function getFavorites() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveFavorites(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('skintypes:favorites:updated'));
  }

  function toggleFavorite(handle) {
    var list = getFavorites();
    var idx = list.indexOf(handle);

    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }

    saveFavorites(list);
    return list;
  }

  function isFavorite(handle) {
    return getFavorites().indexOf(handle) !== -1;
  }

  function updateButtonsState() {
    var favorites = getFavorites();

    document.querySelectorAll('.favorite-toggle[data-favorite-handle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-favorite-handle');
      var active = favorites.indexOf(handle) !== -1;

      btn.classList.toggle('is-favorite', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');

      var icon = btn.querySelector('.favorite-toggle__icon');
      if (icon) {
        icon.textContent = active ? '♥' : '♡';
      }
    });
  }

  // Click ant širdelės
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.favorite-toggle[data-favorite-handle]');
    if (!btn) return;

    event.preventDefault();

    var handle = btn.getAttribute('data-favorite-handle');
    toggleFavorite(handle);
    updateButtonsState();
  });

  // Pirmas pradinės būsenos užkrovimas
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateButtonsState);
  } else {
    updateButtonsState();
  }

  // Eksportas globaliai – kad favorites page galėtų perskaičiuoti
  window.SkintypesFavorites = {
    getFavorites: getFavorites,
    toggleFavorite: toggleFavorite,
    isFavorite: isFavorite,
    refreshButtons: updateButtonsState
  };
})();
